import clsx from 'clsx';
import styles from './ChannelBadge.module.css';

export function ChannelBadge({ channel, className = '' }) {
  const key = String(channel || '')
    .trim()
    .toLowerCase();
  if (!key || key === 'email') return null;

  return (
    <span
      className={clsx(styles.badge, styles[key], className)}
      aria-label={`Channel: ${key.toUpperCase()}`}
    >
      {key.toUpperCase()}
    </span>
  );
}
